<script lang="ts">
  import { CommonTexts } from '../services/CommonTexts';
  import Icon from '../components/icons/Icon.svelte';
  import * as Icons from '@lucide/svelte';
  import { MenuService } from '../services/MenuService.svelte';
  import { PointService } from '../components/points/PointService';
  import { UserService } from '../services/UserService.svelte';

  // -
  const IsLoggedIn = $derived(UserService.body.isLoggedIn);
  const QuickPoints = $derived(Object.entries(MenuService.menuQuick));
</script>

<nav class="LayoutQuick" aria-label={CommonTexts.QuickAccess}>
  {#if IsLoggedIn}
    <a class="quickItem quickSearch" href={MenuService.getSearchHref()} aria-label={CommonTexts.Search} title={CommonTexts.Search}>
      <Icon icon={Icons.Search} size={1.5} />
    </a>
  {/if}
  {#each QuickPoints as [key, point] (key)}
    {@const Link = PointService.buildLink(point.href)}
    {#if Link.hasLink}
      <a class="quickItem" class:active={point.active} href={Link.url} target={Link.target} rel={Link.rel} aria-label={point.label} title={point.label}>
        <Icon icon={point.icon ?? Icons.FlagTriangleRight} size={1.5} alarm={point.alarm} count={point.count} />
      </a>
    {:else if point.onselect}
      <button type="button" class="quickItem" class:active={point.active} aria-label={point.label} title={point.label} onclick={point.onselect}>
        <Icon icon={point.icon ?? Icons.FlagTriangleRight} size={1.5} alarm={point.alarm} count={point.count} />
      </button>
    {/if}
  {/each}
</nav>

<style lang="scss">
  @use '../../styles/mixins';

  .LayoutQuick {
    display: flex;
    gap: 0.5rem;

    .quickSearch {
      display: block;
      @include mixins.greaterNav() {
        display: none;
      }
    }

    .quickItem {
      position: relative;
      cursor: pointer;
    }
  }
</style>
